   //    setTimeout(function () {
   //           const variantId = document.querySelector('.product-variant-id').value;
   //      const priceElements = document.querySelectorAll('.cstmproductprice');
   // priceElements.forEach(el => el.style.display = 'none');
   //  if (variantId) {
   //    const priceChange = document.querySelector(`.pricecstm-${variantId}`);
      
   //    if (priceChange) {
   //      console.log('Price element found for variant:', variantId);
   //      priceChange.style.display = 'block';
   //    } else {
   //      console.log('No price element found for variant:', variantId);
   //    }
   //  }
   //    },500);


// document.addEventListener('DOMContentLoaded', function () {
//   function initializeSliders() {
//     if ($('.main-slider').length && $('.thumb-slider').length && $('.main-slider').children().length > 0 && $('.thumb-slider').children().length > 0) {
//       try {
//         $('.main-slider').slick({
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           arrows: true,
//           fade: true,
//           adaptiveHeight: true,
//           asNavFor: '.thumb-slider',
//           accessibility: true
//         });

//         $('.thumb-slider').slick({
//           slidesToShow: 4,
//           slidesToScroll: 1,
//           asNavFor: '.main-slider',
//           dots: false,
//           centerMode: false,
//           focusOnSelect: true,
//           arrows: false,
//           accessibility: true,
//           responsive: [
//             {
//               breakpoint: 768,
//               settings: { slidesToShow: 3 }
//             },
//             {
//               breakpoint: 480,
//               settings: { slidesToShow: 2 }
//             }
//           ]
//         });
//       } catch (error) {
//         console.error('Error initializing sliders:', error);
//       }
//     } else {
//       console.warn('Slider initialization skipped: Missing slider elements or content');
//     }
//   }
// initializeSliders();
//   // let isSliderInitialized = false; 
//   // window.addEventListener('scroll', function () {
//   //   if (!isSliderInitialized) {
//   //     initializeSliders();
//   //     isSliderInitialized = true;
//   //   }
//   // });

//   // $(document).on('click', 'fieldset.js.product-form__input.product-form__input--pill .variant-container', function () {

//   //   if ($('.main-slider').hasClass('slick-initialized')) {
//   //     try {
//   //       $('.main-slider').slick('unslick');
//   //     } catch (error) {
//   //       console.error('Error unslicking main slider:', error);
//   //     }
//   //   }
//   //   if ($('.thumb-slider').hasClass('slick-initialized')) {
//   //     try {
//   //       $('.thumb-slider').slick('unslick');
//   //     } catch (error) {
//   //       console.error('Error unslicking thumb slider:', error);
//   //     }
//   //   }

//   //   isSliderInitialized = false;

//   //   let intervalId = setInterval(function () {
//   //     if ($('.main-slider').length && $('.thumb-slider').length && $('.main-slider').children().length > 0 && $('.thumb-slider').children().length > 0) {
//   //       initializeSliders();
//   //       isSliderInitialized = true; 
//   //       clearInterval(intervalId);
//   //     } else {
//   //       console.warn('Reinitialization skipped: Sliders or their content are missing after variant click');
//   //     }
//   //   }, 1200);
//   // });
// });
(function () {
   $('#menu-list .menu-item').on('click', function (e) {
    e.preventDefault(); 
    const newURL = $(this).attr('href');
    console.log("newUrl",newURL );
    window.history.pushState({}, "", newURL);
    $('#menu-list .menu-item').removeClass('active');
    $(this).addClass('active');
 
    
});
}) ();
$(document).on("click", ".blog-add-to-cart", function() {
  const id = $(this).attr("data-variant-id"); // Get variant ID from the clicked element
   const $addToCartButton = $(this);
    $addToCartButton.text("Adding...");
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: {
      quantity: 1,
      id: id
    },
    success: function (data) {
      var $addToCart = $(this); // This is wrong, need to refer to the correct element
       $addToCartButton.text("Added");
      $('body').trigger('added.ajaxProduct', $addToCart);
      
      // Dispatch a custom event with product details
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: {
          product: data
        }
      }));
         setTimeout(function() {
        $addToCartButton.text("ADD");
      }, 1500);
      // Update the cart drawer and cart icon bubble
        jQuery.getJSON('/cart.js', function (cart, textStatus) {
         $("cart-drawer-items").html( $(data).find("cart-drawer-items").html() );
        $("#cart-icon-bubble").html( $(data).find("#cart-icon-bubble").html() );
        $("cart-drawer").removeClass("is-empty");
        $("drawer__inner-empty").hide();
        $("cart-drawer").load("/cart #CartDrawer");
        setTimeout(function(){
        $("cart-drawer").addClass("active");
        },500);
        });
    },
    error: function(xhr, status, error) {
      console.log("Error adding to cart: ", error);
    }
  });
});

// document.addEventListener('DOMContentLoaded', function () {
//   let Value;
//   let slidersInitialized = false;

//   function initAllSliders() {
//     if (window.innerWidth < 768) return; // sirf 768 se zyada width pe chalaega

//     document.querySelectorAll('.cstm-svariant-slider:not(.slick-initialized)').forEach(slider => {
//       $(slider).slick({
//         dots: false,
//         arrows: true,
//         infinite: true,
//         speed: 300,
//         slidesToShow: 2,
//         slidesToScroll: 1,
//         responsive: [
//           { breakpoint: 768, settings: { slidesToShow: 3, slidesToScroll: 1 } } // 768 breakpoint
//         ]
//       });

//       // Slider ke liye click event to go to selected slide
//       $(slider).on('click', '.slick-slide', function() {
//         let index = $(this).data('slick-index'); // Get the index of clicked slide
//         console.log("+index"+ index);
//         Value = index;
//         setCookie("index", index, 7);
//         var cookieValue = getCookie('index'); 
  
//         setTimeout(function(){
//           console.log("cookieValue"+cookieValue);
//           $(".cstm-svariant-slider").slick('slickGoTo', cookieValue);
//         }, 1000);
//          // Go to the clicked slide
//       });
//     });

//     slidersInitialized = true;
//   }

//   function destroyAllSliders() {
//     document.querySelectorAll('.cstm-svariant-slider.slick-initialized').forEach(slider => {
//       if ($(slider).hasClass('slick-initialized')) {
//         $(slider).slick('unslick');
//       }
//     });
//     slidersInitialized = false;
//   }

//   // Pehli baar load pe
//   if (window.innerWidth >= 768) {
//     initAllSliders();
//   }

//   // Resize pe
//   let resizeTimer;
//   window.addEventListener('resize', () => {
//     clearTimeout(resizeTimer);
//     resizeTimer = setTimeout(() => {
//       if (window.innerWidth >= 768) {
//         initAllSliders();
//       } else {
//         destroyAllSliders();
//       }
//     }, 200);
//   });

//   // document.addEventListener('variant:change', function () {
//   //   setTimeout(() => {
//   //     if (window.innerWidth >= 768) {
//   //       destroyAllSliders();  
//   //       initAllSliders();     
//   //     }
//   //   }, 50);
//   // });

//   // Agar koi aur script slider ko re-render kare (jaise quick add, etc.)
//   const observer = new MutationObserver(() => {
//     if (window.innerWidth >= 768) {
//       setTimeout(initAllSliders, 100);
//     }
//   });
//   observer.observe(document.body, { childList: true, subtree: true });
//   // var cookieValue = getCookie('index'); 
//   //       setTimeout(function(){
//   //         console.log("cookieValue"+cookieValue);
//   //         $(".cstm-svariant-slider").slick('slickGoTo', cookieValue);
//   //       }, 1000);
// });
// function setCookie(name, value, days) {
//   let expires = "";
//   if (days) {
//     const date = new Date();
//     date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
//     expires = "; expires=" + date.toUTCString();
//   }
//   document.cookie = name + "=" + (value || "") + expires + "; path=/";
// }

// // Function to delete a cookie
// function deleteCookie(name) {
//   document.cookie = name + '=; Max-Age=-99999999; path=/';
// }
  
//   function getCookie(name) {
//   const nameEQ = name + "=";
//   const cookies = document.cookie.split(';');
//   for(let i = 0; i < cookies.length; i++) {
//     let cookie = cookies[i];
//     while (cookie.charAt(0) === ' ') cookie = cookie.substring(1, cookie.length);
//     if (cookie.indexOf(nameEQ) === 0) return cookie.substring(nameEQ.length, cookie.length);
//   }
//   return null;
// }
  